import Swiper, { Lazy, Pagination, Navigation, EffectFade } from "swiper";
import Common from "../modules/common";
import Map from "../utils/map";
import helpers from "../utils/helpers";
import LazyLoad from "vanilla-lazyload";

const TemplateHome = {
  init() {
    this.events();
    this.hero();
    this.map.init();
  },

  events() {
    $("#cform").on("submit", (e) => {
      e.preventDefault();

      const formEl = $(e.currentTarget);

      if (helpers.validate(formEl)) {
        TemplateHome.cformRecaptcha();
      }
    });

    $("input, textarea").on("blur change", function () {
      if ($(this).val().trim().length) {
        $(this).removeClass("error");
      }
    });
  },

  hero() {
    const heroSliderEl = $(".hero-slider");

    if (!heroSliderEl.length) {
      return;
    }

    const heroSlider = new Swiper(heroSliderEl[0], {
      // loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      modules: [Lazy, Pagination, Navigation, EffectFade],
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      pagination: {
        el: heroSliderEl.find(".swiper-pagination")[0],
        clickable: true,
      },
    });

    heroSliderEl.find(".swiper-button--prev").on("click", () => {
      heroSlider.slidePrev();
    });
    heroSliderEl.find(".swiper-button--next").on("click", () => {
      heroSlider.slideNext();
    });

    // Load and play video on swiper
    heroSlider.on("slideChange", function (e) {
      let video = $(".hero-slide").eq(e.realIndex).find(".hero-slide__video");

      // Check if slide has video
      if (!video.length) {
        $(".hero-slide__video").each((_i, item) => {
          item.pause();
        });
        return;
      }

      // Lazyload video or play if loaded
      if (video.hasClass("loaded")) {
        video[0].play();
      } else {
        new LazyLoad({
          elements_selector: ".hero-slide__video",
          callback_loaded: () => {
            video[0].play();
          },
        });
      }
    });
  },

  cformRecaptcha() {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(recaptcha_key, {
          action: "homepage",
        })
        .then(function (token) {
          TemplateHome.submitCform(token);
        });
    });
  },

  submitCform: function (token) {
    let form = $("#cform");
    let formData = new FormData(form[0]);
    formData.append("action", "submit_cform");
    formData.append("token", token);

    $.ajax({
      url: ajaxurl,
      type: "POST",
      processData: false,
      contentType: false,
      data: formData,
      beforeSend() {
        form.addClass("loading");
        form.find(".form-status").addClass("hidden");
      },
      success: function (response) {
        form.removeClass("loading");

        if (response.success) {
          form[0].reset();
        }

        $("#form-message .popup-body")
          .html(response.data.popup)
          .closest(".popup")
          .addClass("active");
      },
    });
  },

  map: {
    init() {
      if ($("#map").length) {
        this.render();
      }
    },

    render() {
      let mapEl = $("#map");

      let lat = mapEl.data("lat");
      let lng = mapEl.data("lng");
      let zoom = mapEl.data("zoom");

      let mapOptions = {
        zoom: zoom,
        center: {
          lat: lat,
          lng: lng,
        },
        scrollwheel: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        styles: Map.style,
      };

      let map = new google.maps.Map(mapEl[0], mapOptions);

      let center = new google.maps.LatLng(lat, lng);

      // Marker and Icon.
      let markerOptions = {
        position: center,
        clickable: false,
        map: map,
        animation: google.maps.Animation.DROP,
      };

      if (mapEl.data("pin")) {
        markerOptions.icon = mapEl.data("pin");
      } else {
        let icon = {
          size: new google.maps.Size(30, 40),
          path: "M15,40Q30,23.886,30,15.388A15.2,15.2,0,0,0,15,0,15.2,15.2,0,0,0,0,15.388Q0,23.886,15,40Z",
          fillColor: $(".header").css("background-color"),
          fillOpacity: 1,
          anchor: new google.maps.Point(15, 40),
          strokeWeight: 0,
          scale: 1,
        };

        markerOptions.icon = icon;
      }

      let marker = new google.maps.Marker(markerOptions);
    },
  },
};

export default TemplateHome;
